import { faFolderPlus } from "@fortawesome/pro-solid-svg-icons"
import { Button, Typography } from "@mui/material"
import { DataGrid, GridColDef } from "@mui/x-data-grid"
import { translate } from "app/language/service"
import { IRootState } from "app/model"
import React from "react"
import { connect } from "react-redux"
import { FlexBox } from "ui/components/FlexBox"
import { ListIdCell } from "ui/components/ListIdCell"
import { Popup } from "ui/components/Popup"
import { getDataGridTexts } from "ui/tools/list"
import { isPhoneScreen } from "ui/tools/responsive"
import { IUserImpersonatorHydrated } from "user/model"
import { getUserDisplayName } from "user/tools/common"

interface IAvailableImpersonatorsPopupProps {
  availableImpersonators: IUserImpersonatorHydrated[]
  onClose: (impersonator?: IUserImpersonatorHydrated) => any
}

interface IAvailableImpersonatorsPopupConnectProps {
  isPhone: boolean
}

const AvailableImpersonatorsPopupFn = ({
  availableImpersonators,
  onClose,
  isPhone
}: IAvailableImpersonatorsPopupProps & IAvailableImpersonatorsPopupConnectProps) => {
  const [selectedImpersonator, setSelectedImpersonator] = React.useState<IUserImpersonatorHydrated | null>(null)
  const columns: Array<GridColDef<IUserImpersonatorHydrated>> = [
    {
      field: "email",
      headerName: translate("label.user"),
      flex: 4,
      renderCell: params => <ListIdCell id={params.row.id} label={getUserDisplayName(params.row)} />
    }
  ]
  return (
    <Popup
      icon={faFolderPlus}
      id="user-form-popup"
      title={translate("user.impersonator.take.title")}
      onClose={() => onClose()}
      minWidth={isPhone ? "calc(100% - 2rem)" : "25rem"}
      maxWidth={isPhone ? "calc(100% - 2rem)" : "30rem"}
      sx={{
        "& .MuiDialogContent-root": {
          maxWidth: "100%",
          maxHeight: "100%"
        },
        "& h2.MuiDialogTitle-root": { minWidth: 0 },
        "& h2.MuiDialogTitle-root p": { marginRight: "1rem" }
      }}>
      <FlexBox
        id="available-impersonate-users-popup"
        fullWidth
        vertical
        sx={{
          "position": "relative",
          "height": "20rem",
          "minHeight": "20rem",
          "maxHeight": "20rem",
          "transition": "all 400ms ease",
          "& > *": {
            width: "100%"
          },
          "& .MuiDataGrid-root": {
            border: "none"
          },
          "& .MuiDataGrid-cell": {
            fontSize: ".8rem",
            fontWeight: 300
          },
          "& .MuiDataGrid-row": {
            cursor: "pointer"
          },
          "& .MuiDataGrid-columnHeader, & .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-cell:focus, & .MuiDataGrid-cell":
            {
              outline: "none !important"
            }
        }}>
        <Typography color="textPrimary" fontSize=".9rem" fontWeight={500}>
          {translate("users.impersonators.available")}
        </Typography>
        {availableImpersonators.length === 0 ? (
          <Typography color="textSecondary" fontSize=".85rem" sx={{ pl: ".5rem" }}>
            {translate("user.impersonator.available.empty")}
          </Typography>
        ) : (
          <DataGrid
            rows={availableImpersonators}
            columns={columns}
            className="available-impersonators"
            rowHeight={40}
            autoPageSize
            getRowId={row => row.user_id}
            selectionModel={selectedImpersonator ? [selectedImpersonator.user_id] : []}
            onSelectionModelChange={newSelectedIds => {
              setSelectedImpersonator(
                newSelectedIds.length > 0
                  ? availableImpersonators.find(i => i.user_id === (newSelectedIds[0] as number))
                  : null
              )
            }}
            // onRowClick={params => setSelectedImpersonator(params.row)}
            localeText={getDataGridTexts()}
          />
        )}
        <FlexBox fullWidth gap jc="end">
          <Button variant="outlined" onClick={() => onClose()}>
            {translate("button.cancel")}
          </Button>
          <Button
            id="impersonate-user-button"
            variant="contained"
            disabled={!selectedImpersonator}
            onClick={() => onClose(selectedImpersonator as IUserImpersonatorHydrated)}>
            {translate("user.take.identity")}
          </Button>
        </FlexBox>
      </FlexBox>
    </Popup>
  )
}

export const AvailableImpersonatorsPopup = connect(
  (state: IRootState): IAvailableImpersonatorsPopupConnectProps => ({
    isPhone: isPhoneScreen(state)
  })
)(AvailableImpersonatorsPopupFn)
